import { useEffect, useState } from "react";

export default function useIsPWAInstalled(): boolean
{
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() =>
  {
    const displayModeCheck = window.matchMedia('(display-mode: standalone)').matches;
    const iosCheck = (window.navigator as any).standalone === true;

    setIsInstalled(displayModeCheck || iosCheck);

    const mediaQuery = window.matchMedia('(display-mode: standalone)');
    const handler = (e: MediaQueryListEvent) => setIsInstalled(e.matches);

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, []);

  return isInstalled;
}
